import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Image } from "@chakra-ui/react";
import ImageAsset from "~/images/yellow-hands.jpg";

export const LeftPanelImage: FC = () => {
  const { t } = useTranslation();

  return (
    <Image
      alt={t("onboarding.someLogisticsPage.alt")}
      objectFit="cover"
      src={ImageAsset}
    />
  );
};
